<app-page-title [title]="'ACCOUNT LINK COMPLETE'"></app-page-title>

<div class="row">
    <div class="col-md-12">
        <div class="form-group">
            Your account has been successfully linked and will now be managed by <strong>{{businessName}}</strong>.
        </div>
    </div>
</div>
